/* eslint-disable no-extend-native */
import React from "react"
import { Button, Input } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import { NotificationManager } from "react-notifications"

const missedHeartbeatsLimitMin = 3
const missedHeartbeatsLimitMax = 50

class ECPcomponent extends React.Component {
  state = {
    webSocket: null,
    heartbeatInterval: null,
    missedHeartbeats: 0,
    callback: null,
    heartbeatMsg: "---heartbeat---",
    missedHeartbeatsLimit: missedHeartbeatsLimitMin,
    idCardNclayer: false,
    kTokensNclayer: false,
    modalPass: false,
    storagePath: "",
    storageAlias: "",
    keyAlias: "",
    password: "",
    keyType: "AUTH",
    tab_1: true,
    tab_2: false,
    tab_3: false,
    tab_4: false,
    tab_5: false,
    buttonSelectCert: false,
    selectCertNCLayerStore: <></>,
    signNCAPassword: "",
    modalNCAInfo: false,
    signNCAEmptyPassword: true,
    signNCAWrongPassword: false,
    signNCATryPanel: false,
    signNCANoCertsInStoreAuth: false,
    signNCANoCertsInStoreSign: false,
    techErrorNCA: false,
    signNCABlock: false,
    NCALayerNotConnected: false,
    signNCATries: "",
    signBINRow: false,
    signOrgNameRow: true,
    signBIN: "",
    signOrgName: "",
    signIIN: "",
    username: "",
    usermail: "",
    signEmail: "",
    signFullName: "",
    beginDate: "",
    endDate: "",
  }

  selectSignType = () => {
    const webSocket = this.state.webSocket
    if (
      webSocket === null ||
      webSocket.readyState === 3 ||
      webSocket.readyState === 2
    ) {
      this.initNCALayer("selectNCAStore")
    } else {
      this.selectNCAStore()
    }
  }

  selectNCAStore = () => {
    this.setState({ buttonSelectCert: true })
    setTimeout(() => {
      this.getData(
        "loadSlotList",
        ["AKKaztokenStore"],
        "selectNCAStoreKazCallback",
      )
    }, 500)
  }

  selectNCAStoreKazCallback = (result) => {
    this.setState({ kTokensNclayer: result.getErrorCode() === "NONE" })
    setTimeout(() => {
      this.getData(
        "loadSlotList",
        ["AKKZIDCardStore"],
        "selectNCAStoreIdCallback",
      )
    }, 500)
  }

  selectNCAStoreIdCallback = (result) => {
    this.setState({
      idCardNclayer: result.getErrorCode() === "NONE",
      buttonSelectCert: false,
    })
    this.showNCAStore()
  }

  showNCAStore = () => {
    let selectCertNCLayerStore = this.state.selectCertNCLayerStore
    let html = ""
    const storage = "PKCS12"
    const kTokens = "AKKaztokenStore"
    const idCards = "AKKZIDCardStore"
    const htmlClass = "modal-btn modal-btn--block"

    if (this.state.kTokensNclayer || this.state.idCardNclayer) {
      selectCertNCLayerStore = this.state.selectCertNCLayerStore

      if (this.state.kTokensNclayer) {
        html +=
          "<input type='button' class='" +
          htmlClass +
          "' onclick='chooseNCAStorage(\"" +
          kTokens +
          '")\' value = "Казтокен">'
      }

      if (this.state.idCardNclayer) {
        html +=
          "<input type='button' class='" +
          htmlClass +
          "' onclick='chooseNCAStorage(\"" +
          idCards +
          '")\' value ="ID card" >'
      }
      html +=
        "<input type='button' class='" +
        htmlClass +
        "' onclick='chooseNCAStorage(\"" +
        storage +
        '")\' value = "Выбрать файл">'

      this.setState({ selectCertNCLayerStore: <>{html}</> })
    } else {
      this.chooseNCAStorage(storage)
    }
  }

  chooseNCAStorage = (storageAlias) => {
    const storagePath = this.state.storagePath
    const args = [storageAlias, "P12", storagePath]
    this.hideChooseNCLayerModal()
    this.setState({ storageAlias: storageAlias })

    this.getData("browseKeyStore", args, "chooseNCAStorageBack")
  }

  hideChooseNCLayerModal = () => {
    this.setState({
      tab_1: true,
      tab_2: false,
      tab_3: false,
      tab_4: false,
      tab_5: false,
    })
  }

  chooseNCAStorageBack = (rw) => {
    const storagePath = this.state.storagePath

    if (rw.getErrorCode() === "NONE") {
      if (storagePath !== null && typeof storagePath !== "undefined") {
        this.setState({ storagePath: rw.getResult() })
        this.openNCAPasswordModal()
      } else {
        this.setState({ storageAlias: "NONE", storagePath: "" })
      }
    } else {
      this.setState({ storageAlias: "NONE", storagePath: "" })
    }
  }

  openNCAPasswordModal = () => {
    this.setState({
      tab_1: false,
      tab_2: false,
      tab_3: true,
      tab_4: false,
      tab_5: false,
      modalPass: true,
    })
    document.getElementById("signNCAPassword").focus()
  }

  setNCAPassword = () => {
    const storageAlias = this.state.storageAlias
    const password = this.state.signNCAPassword
    const storagePath = this.state.storagePath
    const keyType = this.state.keyType
    let args = []
    this.setState({ password: password })
    if (storagePath && storageAlias) {
      if (password) {
        args = [storageAlias, storagePath, password, keyType]
        this.getData("getKeys", args, "setNCAPasswordBack")
      } else {
        this.setState({ modalNCAInfo: true, signNCAEmptyPassword: true })
      }
    } else {
      this.openNcaLayerError()
    }
  }

  ncaLayerErrorCloseAll = () => {
    this.resetInputs()

    this.hideNCALayerNotConnectedModal()
    this.hideNCAPasswordModal()
    this.hideChooseKeyModal()
  }

  resetInputs = () => {
    this.setState({ storageAlias: "" })
    this.setState({ storagePath: "" })
    this.setState({ password: "" })
    this.setState({ keyAlias: "" })
  }

  hideChooseKeyModal = () => {
    this.setState({ tab_4: false })
  }

  hideNCAPasswordModal = () => {
    this.setState({
      tab_1: true,
      tab_2: false,
      tab_3: false,
      tab_4: false,
      tab_5: false,
      signNCAWrongPassword: false,
      signNCAEmptyPassword: false,
      signNCATryPanel: false,
      signNCANoCertsInStoreAuth: false,
      signNCANoCertsInStoreSign: false,
      techErrorNCA: false,
      signNCABlock: false,
      signNCAPassword: "",
    })
  }

  hideNCALayerNotConnectedModal = () => {
    this.setState({ NCALayerNotConnected: false })
  }

  openNcaLayerError = () => {
    this.ncaLayerErrorCloseAll()
  }

  setNCAPasswordBack = (result) => {
    const keyListEl = document.getElementById("keys")
    let slotListArr
    let list
    let counter

    if (result.errorCode === "NONE") {
      keyListEl.options.length = 0
      list = result.result
      slotListArr = list.split("\n")

      for (counter = 0; counter < slotListArr.length; counter++) {
        if (slotListArr[counter] === null || slotListArr[counter] === "") {
          continue
        }

        keyListEl.options[keyListEl.length] = new Option(
          slotListArr[counter],
          counter,
        )
      }

      this.keysOptionChanged()

      if (slotListArr.length === 1) {
        this.getSubDN()
      } else {
        this.setState({
          tab_1: false,
          tab_2: false,
          tab_3: false,
          tab_4: true,
          tab_5: false,
        })
      }
    } else {
      this.setState({ modalNCAInfo: true })
      if (result.errorCode === "WRONG_PASSWORD" && result.result > -1) {
        this.setState({ signNCAWrongPassword: true, signNCATryPanel: true })
        this.setState({ signNCATries: result.result })
      } else if (result.errorCode === "WRONG_PASSWORD") {
        this.setState({ signNCAWrongPassword: true })
      } else {
        if (result.errorCode === "EMPTY_KEY_LIST") {
          const keyType = this.state.keyType
          if (keyType && keyType === "AUTH") {
            this.setState({ signNCANoCertsInStoreAuth: true })
          } else if (keyType && keyType === "SIGN") {
            this.setState({ signNCANoCertsInStoreSign: true })
          } else {
            this.setState({ techErrorNCA: true })
          }
        } else {
        }
      }
      keyListEl.options.length = 0
    }
  }

  getSubDN = () => {
    const alias = this.state.keyAlias
    const password = this.state.password
    const storagePath = this.state.storagePath
    const storageAlias = this.state.storageAlias
    let args = []

    if (storagePath && storageAlias && password && alias) {
      args = [storageAlias, storagePath, alias, password]
      this.getData("getSubjectDN", args, "getSubDNBack")
    } else {
      this.openNcaLayerError()
    }
  }

  getSubDNBack = (result) => {
    if (result.errorCode === "NONE") {
      this.setState({
        tab_1: false,
        tab_2: false,
        tab_3: false,
        tab_4: false,
        tab_5: true,
      })
      this.fillPersonData(result)
      this.fillOrgData(result)

      this.getNotBeforeCall()
    } else {
      this.openNcaLayerError()
    }
  }

  fillOrgData = (data) => {
    const subjectAttrs = data.result.split(",")
    let bin = this.findSubjectAttr(subjectAttrs, "OU")
    const organizationName = this.findSubjectAttr(subjectAttrs, "O")

    if (bin !== null) {
      if (bin.length > 3) {
        bin = bin.substr(3)
      }
      this.setState({
        signBINRow: true,
        signOrgNameRow: true,
        signBIN: bin,
        signOrgName: organizationName.replaceAll('\\"', '"'),
      })
    } else {
      this.setState({ signBINRow: false, signOrgNameRow: false })
    }
  }

  findSubjectAttr = (attrs, attr) => {
    let tmp
    let numb

    for (numb = 0; numb < attrs.length; numb++) {
      tmp = attrs[numb].replace(/^\s\s*/, "").replace(/\s\s*$/, "")
      if (tmp.indexOf(attr + "=") === 0) {
        return tmp.substr(attr.length + 1)
      }
    }

    return null
  }

  fillPersonData = (data) => {
    const { setIinOrBin, setActive, getInfo, setFio } = this.props
    const subjectDN = data.result
    const subjectAttrs = subjectDN.split(",")
    const iin = this.findSubjectAttr(subjectAttrs, "SERIALNUMBER").substr(3)
    const email = this.findSubjectAttr(subjectAttrs, "E")
    let cn = this.findSubjectAttr(subjectAttrs, "CN")
    cn = cn || ""
    let middleName = this.findSubjectAttr(subjectAttrs, "G")
    middleName = middleName || ""
    const fullName = cn.concat(" ").concat(middleName)
    this.setState({
      signIIN: iin,
      username: iin,
      usermail: email,
      signEmail: email,
      signFullName: fullName,
    })
    if (setIinOrBin) {
      setIinOrBin(iin)
    }
  }

  getNotBeforeCall = () => {
    const storageAlias = this.state.storageAlias
    const storagePath = this.state.storagePath
    const password = this.state.password
    const alias = this.state.keyAlias
    let args = []

    if (storagePath && storageAlias && password && alias) {
      args = [storageAlias, storagePath, alias, password]
      this.getData("getNotBefore", args, "getNotBeforeBack")
    } else {
      this.openNcaLayerError()
    }
  }

  getNotBeforeBack = (result) => {
    let beginDate
    if (result.errorCode === "NONE") {
      beginDate = result.result.split(" ")[0]
      this.setState({ beginDate: beginDate })
      this.getNotAfterCall()
    } else {
      this.openNcaLayerError()
    }
  }

  getNotAfterCall = () => {
    const storageAlias = this.state.storageAlias
    const storagePath = this.state.storagePath
    const password = this.state.password
    const alias = this.state.keyAlias
    let args = []

    if (storagePath && storageAlias && password && alias) {
      args = [storageAlias, storagePath, alias, password]
      this.getData("getNotAfter", args, "getNotAfterBack")
    } else {
      this.openNcaLayerError()
    }
  }

  getNotAfterBack = (result) => {
    let endDate
    if (result.errorCode === "NONE") {
      endDate = result.result.split(" ")[0]
      this.setState({ endDate: endDate })
    } else {
      this.openNcaLayerError()
    }
  }

  keysOptionChanged = () => {
    let keys = document.getElementById("keys")
    const str = keys.options[keys.selectedIndex].text
    const alias = str.split("|")[3]
    this.setState({ keyAlias: alias })
  }

  getData = (method, args, callbackM) => {
    const webSocket = this.state.webSocket
    let methodVariable = {
      method: method,
      args: args,
    }
    if (callbackM) {
      this.setState({ callback: callbackM })
    }
    this.setMissedHeartbeatsLimitToMax()
    webSocket.send(JSON.stringify(methodVariable))
  }

  pingLayer = () => {
    const webSocket = this.state.webSocket
    try {
      webSocket.send(this.state.heartbeatMsg)
    } catch (error) {
      clearInterval(this.state.heartbeatInterval)
      this.setState({ heartbeatInterval: null })
      webSocket.close()
    }
    this.setState({ webSocket: webSocket })
  }

  initNCALayer = (callbackM) => {
    const webSocket = new WebSocket("wss://127.0.0.1:13579/")
    const heartbeatInterval = this.state.heartbeatInterval

    webSocket.onopen = () => {
      if (heartbeatInterval === null) {
        this.setState({ missedHeartbeats: 1 })
        // this.setState({ heartbeatInterval: setInterval(this.pingLayer, 1000) })
      }

      if (callbackM) {
        this.functions[callbackM]()
      }
    }

    webSocket.onclose = (e) => {
      if (!e.wasClean) {
        NotificationManager.error(
          "Ошибка с NCALAyer, возможно программа не запушена или  не установлена на вашем компьютере",
        )
      }
    }

    webSocket.onmessage = (e) => {
      let result
      let rw
      if (e.data === this.state.heartbeatMsg) {
        this.setState({ missedHeartbeats: 0 })
        return
      }
      result = JSON.parse(e.data)
      rw = {
        result: result.result,
        secondResult: result.secondResult,
        errorCode: result.errorCode,
        getResult: () => result.result,
        getSecondResult: () => result.secondResult,
        getErrorCode: () => result.errorCode,
      }
      if (this.state.callback) {
        this.functions[this.state.callback](rw)
      }
      this.setMissedHeartbeatsLimitToMin()
    }
    this.setState({ webSocket: webSocket })
  }

  setMissedHeartbeatsLimitToMax = () => {
    this.setState({ missedHeartbeatsLimit: missedHeartbeatsLimitMax })
  }

  setMissedHeartbeatsLimitToMin = () => {
    this.setState({ missedHeartbeatsLimit: missedHeartbeatsLimitMin })
  }

  fillData = () => {
    this.getSubDN()
  }

  doSignXML = () => {
    this.signXmlCall("signXmlBack")
    return false
  }

  signXmlCall = (callbackM) => {
    let data = document.getElementById("xmlToSign").value
    const storageAlias = this.state.storageAlias
    const storagePath = this.state.storagePath
    const password = this.state.password
    const alias = this.state.keyAlias
    let args = []
    let numb

    if (storagePath && storageAlias && password && alias && data) {
      data = document.getElementById("xmlToSign").value
      args = [storageAlias, storagePath, alias, password, data]
      this.getData("signXml", args, callbackM)
    } else {
      this.openNcaLayerError()
    }
  }

  signXml = () => {
    return false
  }

  signXmlBack = (result) => {
    var signedData
    if (result.errorCode === "NONE") {
      signedData = result.getResult()
      document.getElementById("certificate").value = signedData
      this.signStrCall("signStrBack")
    } else if (result.errorCode === "WRONG_PASSWORD" && result.result > -1) {
      NotificationManager.error("Пароль неверен")
      this.openNcaLayerError()
    } else if (result.errorCode === "WRONG_PASSWORD") {
      NotificationManager.error("Пароль неверен")
      this.openNcaLayerError()
    } else {
      document.getElementById("certificate").value = ""
      this.openNcaLayerError()
    }
  }

  signStrBack = (result) => {
    const { setX509, submit, setStep, step } = this.props
    var signedData
    if (result.errorCode === "NONE") {
      signedData = result.getResult()
      setX509(signedData)
      document.getElementById("sign").value = signedData
      // $("#eds_form").submit()
    } else if (result.errorCode === "WRONG_PASSWORD" && result.result > -1) {
      this.openNcaLayerError()
    } else if (result.errorCode === "WRONG_PASSWORD") {
      this.openNcaLayerError()
    } else {
      document.getElementById("certificate").value = ""
      this.openNcaLayerError()
    }
    if (submit) {
      submit(this.state.signIIN, signedData)
    }
    if (step && setStep) {
      setStep(step + 1)
    }
  }

  signStrCall = (callbackM) => {
    let data = document.getElementById("xmlToSign").value
    const storageAlias = this.state.storageAlias
    const storagePath = this.state.storagePath
    const password = this.state.password
    const alias = this.state.keyAlias
    let args = []
    let numb

    if (storagePath && storageAlias && password && alias && data) {
      data = document.getElementById("xmlToSign").value
      args = [storageAlias, storagePath, alias, password, data]
      this.getData("signPlainData", args, callbackM)
    } else {
      this.openNcaLayerError()
    }
  }

  chooseOtherCert = () => {
    const { setIinOrBin } = this.props
    this.setState({
      tab_1: true,
      tab_2: false,
      tab_3: false,
      tab_4: false,
      tab_5: false,
      signBINRow: false,
      signOrgNameRow: false,
      signIIN: "",
      signEmail: "",
      signFullName: "",
      beginDate: "",
      endDate: "",
    })
    if (setIinOrBin) {
      setIinOrBin("")
    }

    this.selectSignType()
  }

  functions = {
    selectNCAStore: this.selectNCAStore,
    selectNCAStoreIdCallback: this.selectNCAStoreIdCallback,
    selectNCAStoreKazCallback: this.selectNCAStoreKazCallback,
    chooseNCAStorageBack: this.chooseNCAStorageBack,
    setNCAPasswordBack: this.setNCAPasswordBack,
    getSubDNBack: this.getSubDNBack,
    getNotBeforeBack: this.getNotBeforeBack,
    getNotAfterBack: this.getNotAfterBack,
    signXmlBack: this.signXmlBack,
    signStrBack: this.signStrBack,
  }

  render() {
    const { visible, t } = this.props
    return (
      <>
        <div style={{ display: visible ? "none" : "block" }}>
          <Input type="hidden" value={this.state.storagePath} />
          <Input type="hidden" value={this.state.storageAlias} />
          <Input type="hidden" value={this.state.keyAlias} />
          <Input type="hidden" value={this.state.password} />
          <Input type="hidden" value={this.state.keyType} />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ display: this.state.tab_1 ? "block" : "none" }}>
              <div>
                <Button
                  content={t("Select certificate")}
                  color="green"
                  onClick={() => {
                    this.selectSignType()
                  }}
                  disabled={this.state.buttonSelectCert}
                />
              </div>
              <div
                style={{
                  display: this.state.NCALayerNotConnected ? "block" : "none",
                }}
              >
                <h4>{t("Error connecting to interlayer")}</h4>
                <div>
                  <p>{t("Make sure the program is running and try again.")}</p>
                  <p>
                    <a
                      href="http://pki.gov.kz/index.php/ru/ncalayer"
                      // eslint-disable-next-line react/jsx-no-target-blank
                      target="_blank"
                    >
                      {t("Instructions for starting the program")}
                    </a>
                  </p>
                  <Button
                    onClick={() => {
                      this.hideNCALayerNotConnectedModal()
                    }}
                    content="ОК"
                  />
                </div>
              </div>
            </div>
            <div style={{ display: this.state.tab_2 ? "block" : "none" }}>
              <h4>{t("Select document type")}</h4>
              <div>{this.state.selectCertNCLayerStore}</div>
              <div>
                <Button
                  onClick={() => {
                    this.hideChooseNCLayerModal()
                  }}
                  content={t("Cancel")}
                />
              </div>
            </div>
            <div style={{ display: this.state.tab_3 ? "block" : "none" }}>
              <h4>{t("Enter the password for the certificate")}</h4>
              <form role="form">
                <Input
                  id="signNCAPassword"
                  type="password"
                  placeholder={t("Password")}
                  value={this.state.signNCAPassword}
                  onChange={(e, d) => {
                    this.setState({ signNCAPassword: d.value })
                  }}
                />
              </form>
              <div
                style={{ display: this.state.modalNCAInfo ? "block" : "none" }}
              >
                <div
                  style={{
                    display: this.state.signNCAWrongPassword
                      ? "inline"
                      : "none",
                  }}
                >
                  {t("Incorrect password")}.
                </div>
                <div
                  style={{
                    display: this.state.signNCAEmptyPassword
                      ? "inline"
                      : "none",
                  }}
                >
                 {t("Enter password")}.
                </div>
                <div
                  style={{
                    display: this.state.signNCATryPanel ? "inline" : "none",
                  }}
                >
                  {t("Attempts left")} <span>{this.state.signNCATries}</span>
                </div>
                <div
                  style={{
                    display: this.state.signNCABlock ? "inline" : "none",
                  }}
                >
                 {t(
                  "EDS for the identity card is blocked. Contact NAO GK `Government for citizens`",
                )}.
                </div>
                <div
                  style={{
                    display: this.state.signNCANoCertsInStoreAuth
                      ? "inline"
                      : "none",
                  }}
                >
                  {t(
                  "Select the certificate for authorization (with the AUTH prefix) and re-enter the password",
                )}
                </div>
                <div
                  style={{
                    display: this.state.signNCANoCertsInStoreSign
                      ? "inline"
                      : "none",
                  }}
                >
                  {t(
                  "Select the certificate to sign the application and re-enter the password",
                )}
                </div>
                <div
                  style={{
                    display: this.state.techErrorNCA ? "inline" : "none",
                  }}
                >
                  {t("A technical error has occurred. Please try again later.")}
                </div>
              </div>
              <div style={{ marginTop: 10 }}>
                <Button
                  positive
                  type="submit"
                  onClick={() => {
                    this.setNCAPassword()
                  }}
                  content={t("Enter")}
                />
                <Button
                  negative
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    this.setNCAPassword()
                  }}
                  content={t("Cancel")}
                />
              </div>
            </div>
            <div style={{ display: this.state.tab_4 ? "block" : "none" }}>
            <h4>{t("Select key")}</h4>
              <div id="selectKey">
                <select
                  onChange={() => {
                    this.keysOptionChanged()
                  }}
                  id="keys"
                ></select>
              </div>
              <div>
                <Button
                  positive
                  onClick={() => {
                    this.fillData()
                    this.hideChooseKeyModal()
                  }}
                  content={t("Choose")}
                />
                <Button
                  negative
                  onClick={() => {
                    this.hideChooseKeyModal()
                  }}
                  content={t("Cancel")}
                />
              </div>
            </div>
            <div style={{ display: this.state.tab_5 ? "block" : "none" }}>
              <h4>{t("Certificate data")}</h4>
              <input
                type="hidden"
                id="xmlToSign"
                value='&lt;?xml version="1.0" encoding="UTF-8"?&gt;&lt;login&gt;&lt;timeTicket&gt;870717000000581049&lt;/timeTicket&gt;&lt;/login&gt;'
              ></input>
              <div id="signPnlSignedXMLS" style={{ visibility: "hidden" }}>
                <input
                  type="hidden"
                  id="certificate"
                  name="certificate"
                ></input>
                <input type="hidden" id="sign" name="sign"></input>
              </div>
              <div style={{ visibility: "hidden" }}>
                <Input
                  type="hidden"
                  name="username"
                  value={this.state.username}
                />
                <Input
                  type="hidden"
                  name="usermail"
                  value={this.state.usermail}
                />
              </div>
              <div style={{ visibility: "hidden" }}>
                <Input id="eds_lvl" type="hidden" name="lvl" value="7" />
              </div>
              <div>
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <th>{t("IIN")}:</th>
                        <td>
                          <span>{this.state.signIIN}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>E-mail:</th>
                        <td>
                          <span>{this.state.signEmail}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>{t("fio")}:</th>
                        <td>
                          <span>{this.state.signFullName}</span>
                        </td>
                      </tr>
                      <tr
                        style={{
                          display: this.state.signBINRow ? "block" : "none",
                        }}
                      >
                        <th>{t("BIN")}:</th>
                        <td>
                          <span>{this.state.signBIN}</span>
                        </td>
                      </tr>
                      <tr
                        style={{
                          display: this.state.signOrgNameRow ? "block" : "none",
                        }}
                      >
                        <th>{t("Name of company")}:</th>
                        <td>
                          <span>{this.state.signOrgName}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Validity")}:</th>
                        <td>
                          <span>{this.state.beginDate}</span> -{" "}
                          <span>{this.state.endDate}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Button
                  positive
                  onClick={() => {
                    this.doSignXML()
                  }}
                  content={t("Submit")}
                  style={{ marginTop: 10 }}
                />
                <Button
                  negative
                  type="button"
                  onClick={() => {
                    this.chooseOtherCert()
                  }}
                  content={t("Choose another certificate")}
                  style={{ marginTop: 10 }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default withTranslation()(ECPcomponent)
